/* If you edit this file, please remove this header and clean up the resulting eslint errors.
*/
/* eslint-disable
  import/no-commonjs,
  import/no-extraneous-dependencies,
  max-len,
  react/no-string-refs,
  react/prop-types
*/
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';
import Header from 'signer/components/common/header';
import Logo from 'signer/components/common/logo';
import Button from 'common/components/button';
import HfReactHelper from 'common/utils/hf-react-helper';
import HeaderAlert from 'signer/components/common/header-alert';
import HeaderAlertTypes from 'signer/components/common/header-alert/header-alert-types';
import createReactClass from 'create-react-class';
import SecurityLogo from './assets/security.png';

require('./index.scss');


const messages = defineMessages({
  sendText: {
    id: '',
    description: 'button text when clicked sends an authentication code via SMS',
    defaultMessage: 'Send code',
  },
  verifyText: {
    id: '',
    description: 'text in signer flow, checking if the sms authentication code provided is valid',
    defaultMessage: 'Verify & continue',
  },
  checkingText: {
    id: '',
    description: 'text in signer flow, checking if the sms code provided is valid',
    defaultMessage: 'Checking...',
  },
  resendText: {
    id: '',
    description: 'text in signer flow, authentication code invalid, prompt signer to resend sms',
    defaultMessage: 'Resend SMS',
  },
  enterCodeText: {
    id: '',
    description: 'text signer flow input box, directing signer to enter 6-digit authentication code',
    defaultMessage: 'Enter 6-digit code',
  },
});

const SmsAuthNumber = createReactClass({
  propTypes: {
    numAttemptsLeft: PropTypes.number,
    signerNumber: PropTypes.string,
    requesterName: PropTypes.string,
    requesterEmail: PropTypes.string,
    callback: PropTypes.func,
  },

  getInitialState() {
    return {
      smsTriggered: false,
      checkFailed: false,
      numAttemptsLeft: this.props.numAttemptsLeft,
      buttonText: this.props.intl.formatMessage(messages.sendText),
    };
  },

  onTriggerSms(evt) {
    evt.preventDefault();

    if (this.state.smsTriggered) {
      const code = HfReactHelper.trim(this.refs.code.value);

      if (code) {
        this.setState({
          buttonText: this.props.intl.formatMessage(messages.checkingText),
        });

        this.props.app.signatureRequest
          .checkSmsCode(code)
          .then(() => {

            this.setState({
              checkFailed: false,
              numAttemptsLeft: null,
            });

            if (this.props.callback) {
              this.props.callback();
            }
          })
          .catch((error) => {
            this.setState({
              checkFailed: true,
              numAttemptsLeft: error.data ? error.data.numAttemptsLeft : null,
              buttonText: this.props.intl.formatMessage(messages.verifyText),
            });
          });
      }
    } else {
      this.setState({
        smsTriggered: true,
        buttonText: this.props.intl.formatMessage(messages.verifyText),
      });

      this.props.app.signatureRequest
        .sendSms()
        .then(() => {
        })
        .catch(() => {
          this.setState({
            checkFailed: false,
          });
        });
    }
  },

  onRetriggerSms(evt) {
    evt.preventDefault();

    this.setState({
      smsTriggered: false,
    }, () => this.onTriggerSms(evt));
  },

  render() {

    let alert;
    let alertMessage;
    let modalHeaderText;
    let modalDescriptionText;
    let input;
    let resendLink;
    const outOfAttempts = (this.state.numAttemptsLeft === 0);
    const showAlert = (this.state.checkFailed || outOfAttempts);

    if (showAlert) {
      alertMessage = outOfAttempts
        ? <FormattedMessage
          id=""
          description="error message in signer flow, informing singer have maxed out the attemps enter in authentication code"
          defaultMessage="You have reached the maximum number of attempts." />
        : <FormattedMessage
          id=""
          description="text in signer flow, informing signer that the authentication code entered is not correct"
          defaultMessage="The authentication code you've entered is incorrect. {attemptsRemaining} {attemptsRemaining, plural, =1 {attempt} other {attempts}} remaining."
          values={{ attemptsRemaining: this.state.numAttemptsLeft }} />;

      alert = (
        <HeaderAlert
          type={HeaderAlertTypes.ERROR}
          message={alertMessage}
          shouldTimeout={false} />
      );
    }

    if (this.state.smsTriggered) {
      modalHeaderText = <FormattedMessage
        id=""
        description="title text in signer flow, indicating signer needs to enter in the authentication code"
        defaultMessage="Enter code" />;

      modalDescriptionText = <FormattedMessage
        id=""
        description="title text in signer flow, asking signer to input sms authentication code"
        defaultMessage="We just sent a text message to <strong>{signerNumber}</strong>"
        values={{ signerNumber: this.props.signerNumber, strong: (str) => <strong key="strong">{str}</strong> }} />;

      input = <input type='text' ref='code' placeholder={this.props.intl.formatMessage(messages.enterCodeText)}></input>;

      resendLink = outOfAttempts
        ? ''
        : <a href='#' className='m-signer-mobile-sms-authentication-code--form-resend' onClick={this.onRetriggerSms}>
          <FormattedMessage
            id=''
            defaultMessage='Send new code'
            description='text in signer flow, link to trigger new SMS message with authentication code' />
        </a>;
    } else {
      modalHeaderText = <FormattedMessage
        id=""
        description="title text in signer flow, indicating signer will need to verify their identity"
        defaultMessage="Verify identity" />;

      modalDescriptionText = <FormattedMessage
        id=""
        description="title text in signer flow, letting signer know a text was sent to the phone number"
        defaultMessage="Security is our top priority. To make sure it’s you, we need to verify via text message to <strong>{signerNumber}</strong>"
        values={{ signerNumber: this.props.signerNumber, strong: (str) => <strong key="strong">{str}</strong> }} />;
    }

    return (
      <div className='m-signer-mobile-sms-authentication-code'>
        <Header {...this.props} className='whitelabel-header'>
          <Logo className='logo' {...this.props} />
        </Header>
        { alert }
        <form className='m-signer-mobile-sms-authentication-code--form' onSubmit={this.onTriggerSms} >
          <img className='m-signer-mobile-sms-authentication-code--form-img' src={SecurityLogo} />
          <label className='m-signer-mobile-sms-authentication-code--form-header'>
            { modalHeaderText }
          </label>
          <label className='m-signer-mobile-sms-authentication-code--form-description'>
            { modalDescriptionText }
            { input }
            { resendLink }

          </label>
          <div className='m-signer-mobile-sms-authentication-code--form-button'>
            <Button buttonText={this.state.buttonText} disabled={outOfAttempts} className='whitelabel-primary-button' type='submit' />
          </div>
          <div className='m-signer-mobile-sms-authentication-code--form-title'>
            <FormattedMessage
              id=""
              description="text in signer flow, title for note"
              defaultMessage="Need help?" />
          </div>
          <div className='m-signer-mobile-sms-authentication-code--form-note'>
            <FormattedMessage
              id=""
              description="text in signer flow, notifying signer to contact sender if the phone number is incorrect"
              defaultMessage="Contact {requesterName} at {requesterEmail}"
              values={{ requesterName: this.props.requesterName, requesterEmail: (<a href={`mailto:${this.props.requesterEmail}`}>{ this.props.requesterEmail }</a>) }} />
          </div>
        </form>

      </div>
    );
  },
});

module.exports = injectIntl(SmsAuthNumber);
